import { Notifier } from '@airbrake/browser';

const airbrake = new Notifier({
  projectId: 492538,
  projectKey: '0a743bbb8d29ed883a63dbcd0cf1bf9c'
});

airbrake.addFilter((notice) => {
  let environment = import.meta.env.MODE;
  if (environment === 'development') {
    return null;
  }
  notice.context.environment = environment;
  return notice;
});

const NETWORK_ERROR_MESSAGES = [
  'Failed to fetch',
  'Load failed',
  'NetworkError when attempting to fetch resource.',
];

airbrake.addFilter((notice) => {
  if ((notice.errors || []).some((e) => e.type === 'TypeError' && NETWORK_ERROR_MESSAGES.includes(e.message))) {
    return null;
  }
  return notice;
});

export default airbrake;
